import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
import { Constants } from './app.constants';
import { HttpHeaders, HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { ErrorhandlerService } from './errorhandler.service';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { StorageService } from './app.storage.service';
import { AttendanceService } from "./attendance-module/attendance.service";
declare var audio:any;
declare var $: any;

@Injectable({
    providedIn: "root"
})

export class AppService{
    constructor(private http: HttpClient,
                private errorHandlerService: ErrorhandlerService,
                private storageService: StorageService, 
                private attendanceService: AttendanceService){

    }

    audio: any = audio;
    
    filteredDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    filteredTaskDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    documentListSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    imageListSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    formDataRendererSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    taskObjectSubscription: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    taskListObjectSubscription: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    reimburseActivityTimestamp: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    userActivityFormSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    statusClaimsListSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    invetedUserObjectSubscription : BehaviorSubject<any> = new BehaviorSubject<any>(null);
    stepsSubject : BehaviorSubject<any> = new BehaviorSubject<any>(null);
    workmateAppLinkSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    newAccountSubject : BehaviorSubject<any> = new BehaviorSubject<any>(null);

    setDataToSubject(data){
        this.filteredDataSubject.next(data);
    }

    setTaskDataToSubject(data){
        this.filteredTaskDataSubject.next(data);
    }

    login(userName, password){
         let url = Constants.BASE_URL + Constants.API_END_POINTS.LOGIN;

         let param = new FormData();
         param.append("userName", userName)
         param.append("password", password);
 
         const httpOptions = {
               headers: new HttpHeaders({ 'No-Auth': "True" }),
               observe: 'response' as 'response'
             };
         
            //  return this.http.post(url, param, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
     
            return this.http.post(url, param, httpOptions).pipe(tap( (result: HttpResponse<any>) => {
                if(result.body.status == Constants.HTTP_STATUS.OK){
                    // console.log(result.body.accountInfo);
                    this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.ACCOUNT_INFO, result.body.accountInfo);
                    
                    let data = result.body.accountInfo;
                    if(data){
                        let featureMap = {};
                        let labelMap = {};
                        if(data.FEATURES){
                            for(let feature of data.FEATURES){
                                featureMap[feature.id] = feature;
                            }
                        }
                        
                        if(data.LABELS){
                            for(let label of data.LABELS){
                                labelMap[label.id] = label;
                            }
                        }
                        this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.FEATURE_MAP, featureMap);
                        this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.LABEL_MAP, labelMap);
                    }
                    
                    



                    // console.log(this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.ACCOUNT_INFO));
                }
                return true;
            }));
    }

    userInfo(accessToken){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.USER_INFO;

        let param = new FormData();
        param.append("accessToken", accessToken);

        const httpOptions = {
              headers: new HttpHeaders({ 'No-Auth': "True" }),
              observe: 'response' as 'response'
            };
        
            // return this.http.post(url, param, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    
           return this.http.post(url, param, httpOptions).pipe(tap( (result: HttpResponse<any>) => {
               if(result.body.status == Constants.HTTP_STATUS.OK){
                   // console.log(result.body.accountInfo);
                   this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.ACCOUNT_INFO, result.body.accountInfo);
                   this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.MANAGER_INFO, result.body.manager);
                   
                   let data = result.body.accountInfo;
                   if(data){
                       let featureMap = {};
                       let labelMap = {};
                       if(data.FEATURES){
                           for(let feature of data.FEATURES){
                               featureMap[feature.id] = feature;
                           }
                       }
                       
                       if(data.LABELS){
                           for(let label of data.LABELS){
                               labelMap[label.id] = label;
                           }
                       }
                       this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.FEATURE_MAP, featureMap);
                       this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.LABEL_MAP, labelMap);
                   }
                   
                   



                   // console.log(this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.ACCOUNT_INFO));
               }
               return true;
           }));
   }

   getStarted(accessToken, userId?){
    let url = Constants.BASE_URL + Constants.API_END_POINTS.GET_STARTED;

    let param = new FormData();
    param.append("accessToken", accessToken);
    if(userId !=null){
        param.append("userId", userId);
    }

    const httpOptions = {
          headers: new HttpHeaders({ 'No-Auth': "True" }),
          observe: 'response' as 'response'
        };
    
       return this.http.post(url, param, httpOptions).pipe(tap( (result: HttpResponse<any>) => {
        if(result.body.status == Constants.HTTP_STATUS.OK){
            // console.log(result.body.accountInfo);
            this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.ACCOUNT_INFO, result.body.accountInfo);
            this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.MANAGER_INFO, result.body.manager);
            
            let data = result.body.accountInfo;
            if(data){
                let featureMap = {};
                let labelMap = {};
                if(data.FEATURES){
                    for(let feature of data.FEATURES){
                        featureMap[feature.id] = feature;
                    }
                }
                
                if(data.LABELS){
                    for(let label of data.LABELS){
                        labelMap[label.id] = label;
                    }
                }
                this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.FEATURE_MAP, featureMap);
                this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.LABEL_MAP, labelMap);
            }
            
            
        }
        return true;
    }));
   }

   requestCallBack(accessToken){
    let url = Constants.BASE_URL + Constants.API_END_POINTS.REQUEST_CALLBACK;
    // let url = "http://10.10.21.153:8080/rev-geocode-1.0.0.0/places/rev_geocode?lat=28.5507160000001&lng=77.2689280000001"

    let param = new FormData();
    param.append("accessToken", accessToken);

    const httpOptions = {
          headers: new HttpHeaders({ 'No-Auth': "True" }),
          observe: 'response' as 'response'
        };
    
       return this.http.post(url, param, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    // return this.http.jsonp(url, "callback");
   }



   createAccount(data){
    let url = Constants.BASE_URL + Constants.API_END_POINTS.CREATE_ACCOUNT;
    let param = new FormData();
    param.append("accessToken", this.storageService.getDataFromLocalStorage("getStartedAccessToken"));
    let paramKeys =Object.keys(data);
    for(let key of paramKeys){
        if(data[key]!=null){
            param.append(key, data[key])
        }
    }

    const httpOptions = {
        headers: new HttpHeaders({ 'No-Auth': "True" }),
        observe : 'response' as 'response'
    }
    return this.http.post(url , param ,httpOptions).pipe(tap( (result: HttpResponse<any>) => {
        if(result.body.status == Constants.HTTP_STATUS.OK){
            // console.log(result.body.accountInfo);
           
            let newAccount = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.NEW_ACCOUNT)
            if(!newAccount || newAccount==undefined){
                this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.ACCOUNT_INFO, result.body.accountInfo);
                this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.MANAGER_INFO, result.body.manager);
                
                let data = result.body.accountInfo;
                if(data){
                    let featureMap = {};
                    let labelMap = {};
                    if(data.FEATURES){
                        for(let feature of data.FEATURES){
                            featureMap[feature.id] = feature;
                        }
                    }
                    
                    if(data.LABELS){
                        for(let label of data.LABELS){
                            labelMap[label.id] = label;
                        }
                    }
                    this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.FEATURE_MAP, featureMap);
                    this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.LABEL_MAP, labelMap);
                }
            }
           
            
            
        }
        return true;
    }));

   }



    refreshToken(mmiId, refreshToken){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.REFRESH_TOKEN;

        let param = new FormData();
        param.append("refreshToken", refreshToken)
        param.append("mmiId", mmiId);

        const httpOptions = {
            //   headers: new HttpHeaders({ 'No-Auth': "True" }),
              observe: 'response' as 'response'
            };
        return this.http.post(url, param, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    
   }
   
    getRevGeoCode(lat, lng){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.REV_GEO_CODE;

        let param = new HttpParams()
        .append("location_lat", lat)
        .append("location_lng", lng);

        const httpOptions = {
           //    headers: new HttpHeaders({ 'No-Auth': "True" }),
            params: param,
              observe: 'response' as 'response'
            };
        
            return this.http.get(url,  httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    
    }
    getRevGeoCodeAllAddress(lat, lng){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.REV_GEO_CODE_ALL_ADDR;

        let param = new HttpParams()
        .append("location_lat", lat)
        .append("location_lng", lng);

        const httpOptions = {
           //    headers: new HttpHeaders({ 'No-Auth': "True" }),
            params: param,
              observe: 'response' as 'response'
            };
        
            return this.http.get(url,  httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    
    }

    getProfilePicture() {
        let url = Constants.BASE_URL + Constants.API_END_POINTS.PROFILE_PICTURE;

        const httpOptions = {
            observe: 'response' as 'response'
        };

        return this.http.post(url, {}, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }

    submitFeedback(title, description, file){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.FEEDBACK;

        let param = new FormData();
        param.append("title", title)
        param.append("description", description)
        if(file){
            param.append("file", file);
        }
        

        const httpOptions = {
            observe: 'response' as 'response'
        };
    
        return this.http.post(url, param, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
                
    }

    autoSuggest(query, location){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.AUTO_SUGGEST;

        let param = new HttpParams()
        .append("query", query)
        .append("location", location);
        
        const httpOptions = {
            params: param,
            observe: 'response' as 'response'
        };
    
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
                
    }
    
    showConfirmationPopup(title,message){
        var infoPopupImg = Constants.INFO_POPUP_IMAGE;
       return Swal.fire({

            html:
                '<div class="alertSection">' +
                '<span class="alertIcon"><img src=' + infoPopupImg + ' alt=""></span>' +
                '<div class="alertCont">' +
                '<h2>' + title + '</h2>' +
                '<p>' + message + '</p>' +
                '</div>' +
                '</div>',
            showCloseButton: false,
            showCancelButton: true,
            showConfirmButton: true,
            focusConfirm: true,
            confirmButtonText: 'Confirm'
        })
        
        
    }

    showInfoPopup(title, message){
       var infoPopupImg = Constants.INFO_POPUP_IMAGE;
        Swal.fire({
            html:
            '<div class="alertSection">'+
            '<span class="alertIcon"><img src='+infoPopupImg+' alt=""></span>'+
            '<div class="alertCont">'+
            '<h2>' + title + '</h2>'+
              '<p>'+ message +'</p>'+
              '</div>'+
              '</div>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false
          })
    }

    showSuccessPopup(title, message){
        var successPopupImg = Constants.SUCCESS_POPUP_IMAGE;
        Swal.fire({
            html:
            '<div class="alertSection">'+
            '<span class="alertIcon"><img src='+successPopupImg+' alt=""></span>'+
            '<div class="alertCont">'+
            '<h2>' + title + '</h2>'+
              '<p>'+ message +'</p>'+
              '</div>'+
              '</div>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false,
            timer : 5000
          })
        
    }

    showErrorPopup(title, message){
        var errorPopupImg = Constants.ERROR_POPUP_IMAGE;
        Swal.fire({
            html:
            '<div class="alertSection">'+
            '<span class="alertIcon"><img src='+errorPopupImg+' alt=""></span>'+
            '<div class="alertCont">'+
            '<h2>' + title + '</h2>'+
              '<p>'+ message +'</p>'+
              '</div>'+
              '</div>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false
          })
    }

    getLable(lab){
        let labelMap = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.LABEL_MAP);

        if(labelMap && labelMap[lab.id]){
            let labelObj = labelMap[lab.id];
            return labelObj.label;
        }
        return lab.defaultLabel;
    }

    isFeature(featureId){
        let featureMap = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.FEATURE_MAP);
       /// return true;
        if(featureMap && featureMap[featureId]){
            let featureObj = featureMap[featureId];
            return featureObj.isActive;
        }
        return true;
    }
    getFormList(isAssignedUser?){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.FORM_LIST;

        let param = new HttpParams()
        if(isAssignedUser){
            param = param.set("isAssignedUser", isAssignedUser)
        }
        const httpOptions={
            params: param,
            observe: 'response' as 'response'
        };
        return this.http.get(url,httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }
    getManagerList(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.MANAGER_LIST;

        const httpOptions = {
            observe : 'response' as 'response'
        };
        return this.http.get(url,httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }
    

    workplaceData: any = {};
    async getWorkPlacesObject(isNewCall?){
        if(isNewCall || Object.keys(this.workplaceData).length <= 0){
            var res:HttpResponse<any> =  await this.getWorkPlaces();
            var workplaces = res.body.workplaces;
            if(workplaces){
                var workplaceMap = {};
                for(let workplace of workplaces){
                    workplaceMap[workplace.id] = workplace;
                }
                this.workplaceData['list'] = workplaces;
                this.workplaceData['map'] = workplaceMap;
            }
            return this.workplaceData;
        
        }else{
            return this.workplaceData;
        }
    }

    getWorkPlaces(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.WORKPLACE_LIST;

        const httpOptions = {
            observe: 'response' as 'response'
        };
        // return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
        return this.http.get(url, httpOptions).toPromise();
    }
    clientActivityObject : any={}
    async getClientObject(isNewCall?){
        if(isNewCall || Object.keys(this.clientActivityObject).length <= 0){
            var res:HttpResponse<any> =  await this.getClientLastActivity();
            var clients = res.body.clientActivity;
            if(clients){
                this.clientActivityObject['list'] = clients;
                let clientMap = {};
                for(let client of clients){
                    clientMap[client.id] = client;
                }
                this.clientActivityObject['map'] = clientMap;
               
            }
            return this.clientActivityObject;
        
        }else{
            return this.clientActivityObject;
        }
    }




    getClientLastActivity() {
        let url = Constants.BASE_URL + Constants.API_END_POINTS.CLIENT_LAST_ACTIVITY;
    
        const httpOptions = {
          observe: 'response' as 'response'
        };
    
         return this.http.get(url, httpOptions).toPromise(); 
      }

    
      uploadProfilePicture(file ){
        let url = Constants.UPLOAD_FILE_URL ;
        let formData = new FormData();
      
        let userInfo = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.USER_INFO);
        
        if(userInfo && userInfo.id){
            formData.append("userId", userInfo.id);
        }
        formData.append("file", file);
    
        const httpOptions = {
            observe : 'response' as 'response'
        }
        return this.http.post(url , formData ,httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    
    }

    uploadClientPicture(clientId, file){
        let url = Constants.UPLOAD_FILE_URL ;

        let formData = new FormData();
        formData.append("partnerId", clientId);
        formData.append("file", file);
    
        const httpOptions = {
            observe : 'response' as 'response'
        }
        return this.http.post(url , formData ,httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    
    }

    getFieldUser(skills?){
        let URL = Constants.BASE_URL + Constants.API_END_POINTS.FIELD_USER_LIST;
    
        let params = new HttpParams();
        if(skills){
           params = params.set("skills", skills);
        }
        const httpOptions ={
            params: params,
            observe : 'response' as 'response'
        } 
        return this.http.get(URL,httpOptions).pipe(catchError(this.errorHandlerService.handleError))
    }

    deleteDocument(docId){
        let URL = Constants.ALFRESCO_BASE_URL + Constants.ALFRESCO_ENDPOINT.DELETE_FILE;
    
        let params = new HttpParams()
        .append("docId", docId);
        
        const httpOptions ={
            params: params,
            observe : 'response' as 'response'
        } 
        return this.http.get(URL, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }
    
    getUsersForReport(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.USERS_FOR_REPORT;

        const httpOptions = {
          observe: 'response' as 'response'
        };
    
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }
    
    getActivityCustomForm(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.ACTIVITY_CUSTOM_FORM_DATA;

        const httpOptions = {
          observe: 'response' as 'response'
        };
    
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
   
    }

    saveActivityCustomFormData(id, activityType, formData){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.ACTIVITY_CUSTOM_FORM_DATA;
    
        let param = new HttpParams()
          .append("id", id)
          .append("activityType", activityType);
    
        const httpOptions = {
          params: param,
          observe: 'response' as 'response'
        };
    
        return this.http.post(url, formData, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
      }
    
      updateActivityCustomFormData(id, formData){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.ACTIVITY_CUSTOM_FORM_DATA +"/"+ id;
    
        let param = new HttpParams()
    
        const httpOptions = {
          params: param,
          observe: 'response' as 'response'
        };
    
        return this.http.post(url, formData, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
      }

    getActivitiesList(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.ACTIVITIES_TYPE;
        const httpOptions ={
            observe : 'response' as 'response'
        }
        return this.http.get(url, httpOptions).toPromise();
    }


    getUserActivityForms(types?){

       

        let url = Constants.BASE_URL + Constants.API_END_POINTS.USER_ACTIVITY_FORMS;

        const httpOptions = {
          observe: 'response' as 'response'
        };
    
        // return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
   
        return this.http.get(url, httpOptions).pipe(tap((res: HttpResponse<any>) => {
                let data = res.body.userActivityForms;
                if(data){
                
                  let actTypeList = Constants.FORM_ACTIVTY_TYPE;
                  if(types){
                      actTypeList = types;
                  }

                  let formObj = {};
                  for(let form of data){
                    for(let actType of actTypeList){
                      if(form.isAssigned && form.activityTypes && form.activityTypes.includes(actType)){
                        let list = formObj[actType];
                        if(list){
                          list.push(form);
                          formObj[actType] = list;
                        }else{
                          let list = [];
                          list.push(form);
                          formObj[actType] = list;
                        }
                      }
                    }
                  }
        
                  this.userActivityFormSubject.next(formObj);
            }
            return true;
        }));

       
    }
    expenseTypeObject: any = [];
    async getExpenseTypeList(isNewCall?){
        if(isNewCall ||this.expenseTypeObject.length <= 0){
            var res:HttpResponse<any> = await this.getExpenseType();
            var expenseTypeList = res.body.expenseTypeList;
            var expenseTypeMap = {};
            for (let obj of expenseTypeList) {
                expenseTypeMap[obj.id] = obj;
            }
            if(expenseTypeList){
                
                this.expenseTypeObject['list'] = expenseTypeList;
                this.expenseTypeObject['map'] = expenseTypeMap;
               
            }
            return this.expenseTypeObject;
        
        }else{
            return this.expenseTypeObject;
        }
    }
    getExpenseType(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.GET_EXPENSE_TYPE;

        const httpOptions = {
            observe : 'response' as 'response'
        }

        return this.http.get(url, httpOptions).toPromise();
    }

    getSkills(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.GET_SKILLS;
    
        const httpOptions = {
            observe: 'response' as 'response'
        };
        
        return this.http.get(url, httpOptions).toPromise(); 
    }
    skillsSetData: any = {};
    async getSkillsSetObject(isNewCall?){
        if(isNewCall || Object.keys(this.skillsSetData).length <= 0){
            var res:HttpResponse<any> =  await this.getSkills();
            var skills = res.body.skillSets;
            var skillMap = {};
            for (let obj of skills) {
                skillMap[obj.id] = obj;
            }
            if(skills){
                
                this.skillsSetData['list'] = skills;
                this.skillsSetData['map'] = skillMap;
               
            }
            return this.skillsSetData;
        
        }else{
            return this.skillsSetData;
        }
    }

    getcompanyDetails(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.FETCH_COMPANY_DETAILS;
    
        const httpOptions = {
            observe: 'response' as 'response'
        };
        
        return this.http.get(url, httpOptions).toPromise(); 
    }
    companyDetailsData: any = {};
    async getcompanyDetailsDataObject(isNewCall?){
        if(isNewCall || Object.keys(this.companyDetailsData).length <= 0){
            var res:HttpResponse<any> =  await this.getcompanyDetails();
            var companyDetails = res.body.companyDetails;
            if(companyDetails){
                this.companyDetailsData = companyDetails;
               
            }
            return this.companyDetailsData;
        
        }else{
            return this.companyDetailsData;
        }
    }
    
    updateClientList(data, departments) {
        let url = Constants.BASE_URL + Constants.API_END_POINTS.UPDATE_CLIENT;

        let param = new HttpParams();
        let paramKeys = Object.keys(data);
        for (let key of paramKeys) {
            if (data[key] != null) {
                param = param.set(key, data[key])
            }
        }
        const httpOptions = {
            params: param,
            headers: new HttpHeaders({ "Content-Type": "application/json" }),
            observe: 'response' as 'response'
        };
        return this.http.post(url, JSON.stringify(departments), httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }
    
    getWorkPlaceColorCode(workPlaceList,officeTypeMap){
        for(let workplace of workPlaceList){
           var officeTypeId = workplace.officeTypeId;
          // var colorCode = 10; // default
           var color;
           if (officeTypeMap[officeTypeId]) {
              let colorCode = officeTypeMap[officeTypeId].colorCode;
               workplace['colorCode'] = colorCode;
           }
          
        //    console.log(colorCode)
        }
      return workPlaceList;
    }

    leaveTypesObject: any = {};
    getLeaveType(){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.LEAVE_TYPE;
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.get(url, httpOptions).toPromise(); 
    }
   
    async getLeaveTypeObject(isNewCall?){
        if(isNewCall || Object.keys(this.leaveTypesObject).length <= 0){
            var res:HttpResponse<any> =  await this.getLeaveType();
            var leaveTypes = res.body.leaveTypes;
            if(leaveTypes){
                this.leaveTypesObject['list'] = leaveTypes;
                let leaveTypeMap = {};
                for(let leaveType of leaveTypes){
                    leaveTypeMap[leaveType.id] = leaveType;
                }
                this.leaveTypesObject['map'] = leaveTypeMap;
               
            }
            return this.leaveTypesObject;
        
        }else{
            return this.leaveTypesObject;
        }
    }


    hideTooltip(classSelector) {
        $('.'+classSelector).each(function () {
            $(this).tooltip('hide');
        });
    }

    enableTooltip(classSelector) {
        let triggerEvent = "hover";
        if ($(window).width <= 768){
            triggerEvent = "click";
        }
        this.hideTooltip(classSelector);
        setTimeout(()=>{
            $('.'+classSelector).each(function () {
                $(this).tooltip(
                    {
                        html: true,
                        trigger: triggerEvent,
                        title: $('#' + $(this).attr('data-tip')).html(),
                        customClass: 'tooltip-custom1'
                    });
            });
        }, 300)
       
    }

    attendanceTypesObject: any = {};
    getAttendnaceType(){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.ATTENDANCE_TYPE
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.get(url, httpOptions).toPromise(); 
    }
   
    async getAttendnaceTypeObject(isNewCall?){
        if(isNewCall || Object.keys(this.attendanceTypesObject).length <= 0){
            var res:HttpResponse<any> =  await this.getAttendnaceType();
            var attendanceTypes = res.body.attendanceTypes;
            if(attendanceTypes){
                this.attendanceTypesObject['list'] = attendanceTypes;
                let attendnaceTypeMap = {};
                for(let leaveType of attendanceTypes){
                    attendnaceTypeMap[leaveType.id] = leaveType;
                }
                this.attendanceTypesObject['map'] = attendnaceTypeMap;
                this.attendanceService.attendanceTypeSubject.next( this.attendanceTypesObject);
            }
            return this.attendanceTypesObject;
        
        }else{
            return this.attendanceTypesObject;
        }
    }

    getUserAccounts(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.GET_USER_ACCOUNTS;

       
        const httpOptions ={
           
            observe : 'response' as 'response'
        } 
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }
    makeDefaultAccount(accountId){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.DEFAULT_USER_ACCOUNT;

        let formData = new FormData();
        formData.append("accountId", accountId);
       
    
        const httpOptions = {
            observe : 'response' as 'response'
        }
        return this.http.post(url , formData ,httpOptions).pipe(catchError(this.errorHandlerService.handleError));
    }
   
    desigObject: any = {};                // for id and name list
    async getDesignationObject(isNewCall?){
      
        if(isNewCall ||Object.keys(this.desigObject).length <= 0){
            var res:HttpResponse<any> = await this.getDesignationList();
            var designationList = res.body.designationList;
            var designationMap = {};
            for (let obj of designationList) {
                designationMap[obj.id] = obj;
            }
            if(designationList){
                
                this.desigObject['list'] = designationList;
                this.desigObject['map'] = designationMap;
               
            }
            return this.desigObject;
        
        }else{
            return this.desigObject;
        }
    }
    getDesignationList(){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.GET_DESIGNATION;

        const httpOptions = {
            observe : 'response' as 'response'
        }

        return this.http.get(url, httpOptions).toPromise();
    }
    typeMasterObject: any = {};
    getTypeMaster(type){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.ACTIVITIES_TYPE ;
        let param = new HttpParams()
        .append("type" ,type)

        const httpOptions = {
            params : param ,
            observe: 'response' as 'response'
        };
        return this.http.get(url, httpOptions).toPromise(); 
    }
   
    async getTypeMasterObject(isNewCall?,type?){
        if(isNewCall || Object.keys(this.typeMasterObject).length <= 0){
            var res:HttpResponse<any> =  await this.getTypeMaster(type);
            var typeMaster = res.body.types;
            if(typeMaster){
                this.typeMasterObject['list'] = typeMaster;
                let typeMasterObjectMap = {};
                for(let type of typeMaster){
                    typeMasterObjectMap[type.id] = type;
                }
                this.typeMasterObject['map'] = typeMasterObjectMap;
               
            }
            return this.typeMasterObject;
        
        }else{
            return this.typeMasterObject;
        }
    }

    getCurrentLoaction():Promise<any>{
        return new Promise((resolve,rejects)=>{
            if(navigator.geolocation.getCurrentPosition){
                // console.log("second call")
                navigator.geolocation.getCurrentPosition(res=>{
                    console.warn(res)
                    resolve({
                        lat : res.coords.latitude,
                        lng : res.coords.longitude,
                    })
                    
                },(error)=>{
                     console.log(error)
                    rejects(error);
                   
                    
                },{
                    timeout: 5000,
                    maximumAge: 200
            
                  })
            }else{
                rejects();
            }
            
        })
    }
    
    saveActivityCustomFormDataForOnRequest(id, activityType, formData){
        let url = Constants.BASE_URL + Constants.API_END_POINTS.ACTIVITY_CUSTOM_FORM_DATA_FOR_ONREQUEST;
    
        let param = new HttpParams()
          .append("id", id)
          .append("activityType", activityType);
    
        const httpOptions = {
          params: param,
          observe: 'response' as 'response'
        };
    
        return this.http.post(url, formData, httpOptions).pipe(catchError(this.errorHandlerService.handleError));
      }
      getFieldUserByClient(clientId,skills?){
        let URL = Constants.BASE_URL + Constants.API_END_POINTS.FIELD_USER_LIST_BY_CLIENT;
    
        let params = new HttpParams();
        if(skills){
         
           params = params.set("skills", skills);
        }
        if(clientId){
            params = params.set("client", clientId);
        }
        const httpOptions ={
            params: params,
            observe : 'response' as 'response'
        } 
        return this.http.get(URL,httpOptions).pipe(catchError(this.errorHandlerService.handleError))
    }
}